import { TipResult, TypesOfContent } from '@app/graphql'
import { ContentUserData, UpvoteStatus, AllUserRoles } from '@app/types'
import { FC } from 'react'
import styled from 'styled-components'
import FeedPostActions from './FeedPostActions'

interface FeedPostContainerProps {
  id: string;
  type?: TypesOfContent;
  className?: string;
  user: ContentUserData;
  createdAt: Date;
  updatedAt?: Date;
  isPrivate?: boolean;
  noActions?: boolean;
  upvotes: number;
  downvotes: number;
  upvoteStatus?: UpvoteStatus;
  commentsAllowed: boolean;
  commentsCount?: number;
  children?: React.ReactNode;
  bookieName?: string;
  status?: TipResult;
  onDelete?: () => void;
  editMode?:() => void;
  pinContentAccess?:AllUserRoles[]
  onUpdateResultMode?:(payload:string) => any;
  isPostTip?: boolean;
  stake?: number;
  odds?: number;
  profit?: string;
  isExpanded?: boolean;
  onShowMore?: () => void;
  showShowMore?: boolean;
  isBlocked?: boolean;
  saved?: boolean;
  multiple?: boolean;
  sportIds?: string[];
  hideSave?: boolean;
}

const FeedPostContainer: FC<FeedPostContainerProps> = ({
  id,
  type = TypesOfContent.Post,
  children,
  className,
  noActions,
  upvotes,
  downvotes,
  upvoteStatus,
  commentsAllowed = true,
  commentsCount,
  stake,
  odds,
  profit,
  isBlocked,
  createdAt,
  saved,
  multiple,
  sportIds,
  hideSave,
}) => {
  const hasBorderRadius = type === TypesOfContent.Poll || type === TypesOfContent.Post
  return (
    <Container className={className} type={type}>
      <Content $hasBorderRadius={hasBorderRadius}>
        {children}
        { !noActions && !isBlocked &&
          <ActionsWrapper isBlocked={isBlocked}>
            <FeedPostActions
              id={id}
              upvotes={upvotes}
              downvotes={downvotes}
              status={upvoteStatus}
              contentType={type}
              commentsAllowed={commentsAllowed}
              commentsCount={commentsCount}
              stake={stake}
              odds={odds}
              profit={profit}
              saved={saved}
              multiple={multiple}
              createdAt={createdAt}
              sportIds={sportIds}
              hideSave={hideSave}
            />
          </ActionsWrapper>
        }
      </Content>
    </Container>
  )
}

const Container = styled.div<{ type: TypesOfContent }>`
  -webkit-transform: translate3d(0,0,0);
  position: relative;
  background: transparent;
  display: flex;
  flex-direction: column;

  .color-pill {
      position: absolute;
      top: -1px;
      left: 0px;
      right: 0px;
      height: 5px;
     ${props => props.type === TypesOfContent.Post && 'background: var(--new-color-gold);'}
      border-radius: 15px;
  }
`

const Content = styled.div<{ $hasBorderRadius?: boolean }>`
  background: var(--tip-card-header-gradient);
  ${props => props.$hasBorderRadius && 'border-radius: 8px;'}
`

const ActionsWrapper = styled.div<{ isBlocked?: boolean }>`
  ${({ isBlocked }) => isBlocked && 'filter: blur(16px); pointer-events: none;'}
`

export default FeedPostContainer
